import { useEffect, useState } from 'react';
import { useAuthStore } from '../services/auth/authStore';
import { PushNotificationService } from '../services/push-notifications/pushNotificationService';

export const usePushNotifications = () => {
	const [isInitialized, setIsInitialized] = useState(false);
	const [error, setError] = useState<Error | null>(null);
	const accessToken = useAuthStore((state) => state.accessToken);

	useEffect(() => {
		const initializeNotifications = async () => {
			// Only initialize if user is authenticated
			if (!accessToken) {
				return;
			}

			try {
				const service = PushNotificationService.getInstance();
				await service.initializePushNotifications();
				setIsInitialized(true);
			} catch (err) {
				setError(err instanceof Error ? err : new Error('Failed to initialize push notifications'));
			}
		};

		initializeNotifications();
	}, [accessToken]); // Re-run when authentication state changes

	return { isInitialized, error };
};
